module.exports = require('./helpers/bundle-url').getBundleURL('byUka') + "person1.f021840b.png" + "?" + Date.now();